var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoggout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 1.69596V15.0293H2.00016V1.69596H12.0002ZM12.0002 0.0292969H2.00016C1.0835 0.0292969 0.333496 0.779297 0.333496 1.69596V16.696H13.6668V1.69596C13.6668 0.779297 12.9168 0.0292969 12.0002 0.0292969ZM9.91683 7.11263C9.22516 7.11263 8.66683 7.67096 8.66683 8.36263C8.66683 9.0543 9.22516 9.61263 9.91683 9.61263C10.6085 9.61263 11.1668 9.0543 11.1668 8.36263C11.1668 7.67096 10.6085 7.11263 9.91683 7.11263Z",
    fill: "#FF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoggout);
export default __webpack_public_path__ + "static/media/loggout.2cb6f3d1a7033c6b351cc2eed40171da.svg";
export { ForwardRef as ReactComponent };